import {
    FilterType,
} from 'app/enums/common.enums'
import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    LongTermLeaseFeeStatus,
} from 'app/enums/label.enums'
import {
    LongTermLeaseFeeFilterRequestView,
} from './LongTermLeaseFees.types'

const longTermLeaseFeesColumns: RichTableColumns<keyof LongTermLeaseFeeFilterRequestView>[] = [
    {
        id: 'longTermLeaseFeesNumber',
        mapCellProps: 'longTermLeaseFeesNumber',
        headerProps: {
            children: 'LT Lane Fees Number',
        },
    },
    {
        headerProps: {
            children: 'Status',
        },
        id: 'longTermLeaseFeesStatus',
        mapCellProps: 'longTermLeaseFeesStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: LongTermLeaseFeeStatus,
    },
    {
        headerProps: {
            children: 'Valid From',
        },
        id: 'validFrom',
        mapCellProps: 'validFrom',
        filterField: 'validFrom',
        filterType: FilterType.DateRange,
        componentName: 'DateTimeCell',
    },
    {
        headerProps: {
            children: 'Valid To',
        },
        id: 'validTo',
        mapCellProps: 'validTo',
        filterField: 'validTo',
        filterType: FilterType.DateRange,
        componentName: 'LaneDateEnriched',
    },
    {
        headerProps: {
            children: 'Changed On',
        },
        id: 'changedOn',
        mapCellProps: 'changedOn',
        filterField: 'changedOn',
        componentName: 'DateTimeCell',
    },
    {
        headerProps: {
            children: 'Changed By',
        },
        id: 'changedBy',
        mapCellProps: 'changedBy',
        filterField: 'changedBy',
    },
]

export default longTermLeaseFeesColumns
